


































import { defineComponent, ref } from "@vue/composition-api";
import { FileData, InputFileId } from "@scrile/api-provider/dist/api/FileProvider";
import { UploadProgress } from "@scrile/tools/dist/lib/FileUploader";
import useAuthUser from "@/hooks/useAuthUser";
import useFiles from "@/hooks/useFiles";
import BaseIcon from "@/components/BaseIcon";
import BaseInputFile from "@/components/BaseInputFile";
import BaseSpinner from "@/components/BaseSpinner";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import LivePreviewItem from "@/components/LivePreviewItem";

export default defineComponent({
  name: "PreviewInputFile",
  components: {
    LivePreviewItem,
    BaseSpinner,
    LoadingThumbnail,
    BaseInputFile,
    BaseIcon,
  },
  setup() {
    const { findFiles, uploadThenUpdate, deleteFile } = useFiles();
    const { authUserStrict } = useAuthUser();
    const loading = ref(false);
    const deleting = ref(false);
    const uploading = ref(false);
    const uploadProgress = ref<number>(100);
    const preview = ref<FileData | null>(null);

    const getData = async () => {
      try {
        loading.value = true;
        const files = await findFiles({
          fileIds: [
            {
              subjectId: authUserStrict.value.id,
              type: "livepreview_manual",
            },
          ],
        });
        preview.value = files[0] ?? null;
      } finally {
        loading.value = false;
      }
    };

    const updatePreview = async (file: FileList) => {
      if (file.length === 0) return;
      try {
        uploading.value = true;
        const onUploadProgress = (progress: UploadProgress) => {
          const res = ((progress?.loaded ?? 0) / (progress?.total ?? 0)) * 100;
          uploadProgress.value = res === 100 ? 99.9 : res;
        };
        const fileId: InputFileId = {
          type: "livepreview_manual",
          subjectId: authUserStrict.value.id,
        };
        preview.value = await uploadThenUpdate({
          fileId,
          file: file[0],
          onUploadProgress,
          onSuccess: () => {
            uploadProgress.value = 100;
          },
        });
      } finally {
        uploading.value = false;
      }
    };

    const deletePreview = async () => {
      try {
        deleting.value = true;
        await deleteFile({
          fileId: {
            subjectId: authUserStrict.value.id,
            type: "livepreview_manual",
          },
        });
        preview.value = null;
      } finally {
        deleting.value = false;
      }
    };

    getData();

    return { loading, uploading, preview, uploadProgress, authUserStrict, deleting, updatePreview, deletePreview };
  },
});
